export default {"src":"/_next/static/media/DX.ad04cd5d.svg","height":18,"width":18};